<template>
  <div>
    <a href="javascript:void(0);" @click="showModal" class="btn-wrapper" v-if="btnType == 'news'">
      <span class="btn btn_play circle" aria-hidden="true">
        <span class="icon arrow"></span>
      </span>
      <span class="button-text">Play video</span>
    </a>

    <a
      href="javascript:void(0);"
      class="btn btn_icon video-pop-up"
      @click="showModal"
      v-if="btnType == 'match'"
    >
      <span class="text">
        <svg
          width="13"
          height="15"
          viewBox="0 0 13 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0938 7.72096L0.930966 14.6411L0.930965 0.776661L12.0938 7.72096Z"
            fill="white"
          />
        </svg>
        play video review
      </span>
    </a>
  </div>
</template>
<script>
import { disablePageScroll } from "scroll-lock";
export default {
  props: {
    btnType: String,
    videoLink: String,
  },
  methods: {
    showModal() {
      var payloader = {
        videoLink: this.videoLink,
        show: true,
      };
      this.$store.commit("showModal", payloader);
      const scrollY = document.documentElement.style.getPropertyValue(
        "--scroll-y"
      );
      const body = document.body;
      body.style.position = "fixed";
      body.style.top = `-${scrollY}`;
    },
  },
};
</script>